import { Link, useLocation } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import {
  LayoutDashboard,
  ShoppingBag,
  ShoppingBasket,
  Package,
  Users,
  Tag,
  Truck,
  Settings,
  BarChart3,
  Megaphone,
  FileText,
  LogOut,
  Upload,
  Image as ImageIcon,
  Sliders,
  MessageSquare,
  CircleDot,
  Palette,
  Menu as MenuIcon,
  Award,
  LayoutTemplate,
  CreditCard,
  HelpCircle,
  Zap,
  FileEdit,
  UserCog,
  Copy,
  ClipboardList,
  Database,
  Folder,
  Search,
  BookOpen,
  Rss,
  Send as SendIcon,
  HardDrive,
  Activity,
  Mail,
  RefreshCcw,
  ShoppingCart,
  ClipboardCheck,
  LineChart,
  Warehouse,
  Heart,
  Search as SearchIcon,
  Boxes,
  ImagePlus,
  Shield,
  Bell,
  PieChart,
  Undo2,
  Receipt,
  ReceiptText,
  Star,
  PanelBottom,
  PackageCheck,
} from 'lucide-react'
import { useAuth } from '../store/auth'
import { apiGet } from '../lib/api'

type NavItem = {
  to: string
  icon: typeof LayoutDashboard
  label: string
  badgeKey?: 'pedidosPendientes' | 'enviosPendientes'
}

type NavSection = {
  section: string
  items: NavItem[]
}

const NAV: NavSection[] = [
  { section: 'General', items: [
    { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/pedidos', icon: ShoppingBag, label: 'Pedidos', badgeKey: 'pedidosPendientes' },
    { to: '/pedidos/nuevo', icon: ShoppingBasket, label: 'Nuevo pedido' },
    { to: '/picking-list', icon: ClipboardCheck, label: 'Picking list' },
  ]},
  { section: 'Catálogo', items: [
    { to: '/productos', icon: Package, label: 'Productos' },
    { to: '/recomendados', icon: Star, label: 'Recomendados (home)' },
    { to: '/productos/carga-masiva', icon: Upload, label: 'Carga masiva' },
    { to: '/productos/imagenes-masivas', icon: ImagePlus, label: 'Imágenes masivas' },
    { to: '/proveedores', icon: Boxes, label: 'Importar de proveedores' },
    { to: '/productos/duplicados', icon: Copy, label: 'Duplicados' },
    { to: '/banco-imagenes', icon: Folder, label: 'Banco de imágenes' },
    { to: '/buscador', icon: SearchIcon, label: 'Buscador (sinónimos)' },
    { to: '/categorias', icon: Tag, label: 'Categorías' },
    { to: '/marcas', icon: Tag, label: 'Marcas' },
  ]},
  { section: 'Llantas', items: [
    { to: '/llantas', icon: CircleDot, label: 'Llantas' },
    { to: '/llantas/nueva', icon: Package, label: 'Nueva llanta' },
    { to: '/llantas/carga-masiva', icon: Upload, label: 'Carga masiva' },
    { to: '/llantas/marcas', icon: Tag, label: 'Marcas de llantas' },
    { to: '/llantas/proveedores', icon: Truck, label: 'Proveedores' },
  ]},
  { section: 'Marketing', items: [
    { to: '/secciones-home', icon: LayoutTemplate, label: 'Secciones home' },
    { to: '/banners', icon: ImageIcon, label: 'Banners' },
    { to: '/slider', icon: Sliders, label: 'Slider home' },
    { to: '/beneficios', icon: Award, label: 'Beneficios' },
    { to: '/reviews', icon: MessageSquare, label: 'Reseñas' },
    { to: '/testimonios', icon: MessageSquare, label: 'Testimonios' },
    { to: '/promo-bar', icon: Zap, label: 'Promo bar' },
    { to: '/feeds', icon: Rss, label: 'Feeds (Google/FB)' },
    { to: '/seo-tools', icon: Search, label: 'SEO automático' },
  ]},
  { section: 'CRM', items: [
    { to: '/clientes', icon: Users, label: 'Clientes' },
    { to: '/cupones', icon: Megaphone, label: 'Cupones' },
    { to: '/newsletter', icon: SendIcon, label: 'Newsletter' },
    { to: '/carritos-abandonados', icon: ShoppingCart, label: 'Carritos abandonados' },
    { to: '/wishlist-analytics', icon: Heart, label: 'Wishlist analytics' },
  ]},
  { section: 'Contenido', items: [
    { to: '/paginas', icon: FileEdit, label: 'Páginas (envíos, FAQ, etc.)' },
    { to: '/blog', icon: FileText, label: 'Blog' },
    { to: '/faq', icon: HelpCircle, label: 'Preguntas frecuentes' },
    { to: '/textos', icon: FileText, label: 'Textos del sitio' },
    { to: '/menu', icon: MenuIcon, label: 'Menú header' },
    { to: '/footer', icon: PanelBottom, label: 'Footer' },
    { to: '/email-templates', icon: Mail, label: 'Plantillas de email' },
  ]},
  { section: 'Operaciones', items: [
    { to: '/autorizar-envios', icon: PackageCheck, label: 'Autorizar envíos', badgeKey: 'enviosPendientes' },
    { to: '/envios', icon: Truck, label: 'Zonas de envío' },
    { to: '/reportes', icon: BarChart3, label: 'Reportes ventas' },
    { to: '/reportes-cierre', icon: PieChart, label: 'Cierre financiero' },
    { to: '/libro-ventas', icon: BookOpen, label: 'Libro de ventas' },
    { to: '/analytics-avanzado', icon: LineChart, label: 'Analytics avanzado' },
    { to: '/reportes-calidad', icon: ClipboardList, label: 'Reportes catálogo' },
    { to: '/importar-datos', icon: Database, label: 'Importar stock / compat.' },
    { to: '/sucursales', icon: Truck, label: 'Sucursales' },
    { to: '/devoluciones', icon: Undo2, label: 'Devoluciones (RMA)' },
    { to: '/refunds', icon: Receipt, label: 'Reembolsos' },
    { to: '/facturas', icon: ReceiptText, label: 'Facturas (CFDI)' },
  ]},
  { section: 'Sistema', items: [
    { to: '/payment-methods', icon: CreditCard, label: 'Pasarelas de pago' },
    { to: '/facturacion', icon: ReceiptText, label: 'Facturación (CFDI)' },
    { to: '/configuracion', icon: Settings, label: 'Configuración' },
    { to: '/branding', icon: Palette, label: 'Branding' },
    { to: '/admins', icon: UserCog, label: 'Admins y operadores' },
    { to: '/roles', icon: Shield, label: 'Roles y permisos' },
    { to: '/notif-channels', icon: Bell, label: 'Notificaciones push' },
    { to: '/mi-cuenta', icon: Users, label: 'Mi cuenta' },
    { to: '/sistema/backup', icon: HardDrive, label: 'Backup BD' },
    { to: '/logs', icon: Activity, label: 'Logs sistema' },
    { to: '/audit-log', icon: Activity, label: 'Audit log' },
  ]},
]

export function Sidebar() {
  const { pathname } = useLocation()
  const { user, logout } = useAuth()

  const { data: pedidosData } = useQuery<{ total: number }>({
    queryKey: ['sidebar-pedidos-pendientes'],
    queryFn: () => apiGet('/api/admin/pedidos?status=pendiente&limit=1'),
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: false,
  })

  const { data: enviosData } = useQuery<{ total: number }>({
    queryKey: ['sidebar-envios-pendientes'],
    queryFn: () => apiGet('/api/admin/envios/cola?limit=1'),
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: false,
  })

  const badges: Record<string, string | undefined> = {
    pedidosPendientes:
      pedidosData && pedidosData.total > 0 ? String(pedidosData.total) : undefined,
    enviosPendientes:
      enviosData && enviosData.total > 0 ? String(enviosData.total) : undefined,
  }

  return (
    <aside className="flex h-screen w-60 shrink-0 flex-col border-r border-ink-200 bg-ink-950 text-ink-100">
      {/* Logo */}
      <div className="flex items-center gap-2 border-b border-white/10 px-5 py-4">
        <div className="grid size-9 place-items-center rounded-lg bg-brand-600 font-extrabold text-white">
          M
        </div>
        <div className="leading-tight">
          <div className="text-sm font-extrabold text-white">MAZ Admin</div>
          <div className="text-[10px] text-ink-300">v2.0.0-beta</div>
        </div>
      </div>

      {/* Nav */}
      <nav className="scrollbar-thin flex-1 overflow-y-auto px-3 py-4">
        {NAV.map((sec) => (
          <div key={sec.section} className="mb-5">
            <div className="mb-1.5 px-3 text-[10px] font-semibold uppercase tracking-widest text-ink-300">
              {sec.section}
            </div>
            <ul className="space-y-0.5">
              {sec.items.map((item) => {
                const active = pathname === item.to || (item.to !== '/' && pathname.startsWith(item.to))
                const badge = item.badgeKey ? badges[item.badgeKey] : undefined
                return (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      className={`group flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                        active
                          ? 'bg-brand-600 text-white shadow-sm'
                          : 'text-ink-100 hover:bg-white/5'
                      }`}
                    >
                      <item.icon className="size-4 shrink-0" />
                      <span className="flex-1">{item.label}</span>
                      {badge && (
                        <span className={`rounded-full px-1.5 py-0.5 text-[10px] font-bold ${
                          active ? 'bg-white/20 text-white' : 'bg-brand-600 text-white'
                        }`}>
                          {badge}
                        </span>
                      )}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        ))}
      </nav>

      {/* User */}
      <div className="border-t border-white/10 p-3">
        <div className="flex items-center gap-3 rounded-md px-3 py-2">
          <div className="grid size-9 place-items-center rounded-full bg-brand-600 text-sm font-bold text-white">
            {user?.name.charAt(0) ?? 'U'}
          </div>
          <div className="flex-1 leading-tight">
            <div className="truncate text-sm font-medium text-white">{user?.name ?? 'Usuario'}</div>
            <div className="truncate text-[10px] text-ink-300">{user?.email ?? '—'}</div>
          </div>
          <button
            type="button"
            onClick={logout}
            title="Salir"
            className="rounded-md p-1.5 text-ink-300 transition-colors hover:bg-white/10 hover:text-white"
          >
            <LogOut className="size-4" />
          </button>
        </div>
      </div>
    </aside>
  )
}
